<template>
  <div class="aic-modal">
    <div class="modal-header">
      <h2>Форма проверки учащегося (АИК)</h2>
    </div>

    <div class="modal-body">
      <div v-if="violationsCheck" class="violation-alert">
        <div class="alert-icon">⚠️</div>
        <div class="alert-content">
          <strong>Внимание!</strong> У ученика есть нарушения за последние 5
          дней
        </div>
      </div>

      <form @submit.prevent="submitForm" class="aic-form">
        <!-- Основная информация -->
        <div class="basic-info">
          <div class="form-group">
            <label for="inspectionDate">Дата проверки *</label>
            <input
              type="date"
              id="inspectionDate"
              v-model="formData.date"
              required
            />
          </div>

          <div class="form-group">
            <label for="inspectorName">ФИО проверяющего *</label>
            <input
              type="text"
              id="inspectorName"
              v-model="formData.inspectorName"
              placeholder="Введите ФИО"
              required
            />
          </div>
        </div>

        <div class="form-group">
          <label for="studentName">ФИО учащегося</label>
          {{ studentData.FirstName }}
          {{ studentData.LastName }}
        </div>

        <!-- <div class="form-group">
          <label for="studentID">ID учащегося *</label>
          <input
            type="text"
            id="studentID"
            v-model="formData.studentID"
            placeholder="Введите ID ученика"
            required
          />
        </div> -->

        <!-- Критерии оценки -->
        <div class="criteria-grid">
          <div
            v-for="criterion in criteria"
            :key="criterion.key"
            class="criteria-item"
          >
            <div class="criteria-title">{{ criterion.title }}</div>
            <div class="rating-options">
              <div
                v-for="option in criterion.options"
                :key="option.value"
                class="rating-option"
                :class="{
                  selected:
                    formData.evaluations[criterion.key] === option.value,
                }"
                @click="selectRating(criterion.key, option.value)"
              >
                <div class="rating-value">{{ option.value }}</div>
                <div class="rating-desc">{{ option.description }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Комментарий -->
        <div class="form-group">
          <label for="comment">Общий комментарий</label>
          <textarea
            id="comment"
            v-model="formData.comment"
            rows="3"
            placeholder="Введите дополнительные комментарии..."
          ></textarea>
        </div>

        <!-- Кнопки -->
        <div class="buttons">
          <button type="button" class="btn-cancel" @click="$emit('close')">
            Отмена
          </button>
          <button type="submit" class="btn-submit" :disabled="!isFormValid">
            Сохранить проверку
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import TutorialDataService from "../../services/TutorialDataService";

export default {
  name: "AICModal",
  props: {
    studentData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      marks: [],
      violationsList: [],
      violationsCheck: false,
      formData: {
        date: this.getTodayDate(),
        inspectorName: "",
        studentID: "",
        comment: "",
        evaluations: {
          diary: null,
          preparation: null,
          homework: null,
          appearance: null,
          behavior: null,
          performance: null,
          attendance: null,
          extracurricular: null,
        },
      },
      criteria: [
        {
          key: "diary",
          title: "Наличие дневника",
          options: [
            { value: 0, description: "Нет" },
            { value: 1, description: "Наличие" },
            { value: 2, description: "Все ДЗ заполнены" },
          ],
        },
        {
          key: "preparation",
          title: "Подготовка к урокам",
          options: [
            { value: 0, description: "Нет" },
            { value: 1, description: "Все тетради" },
            { value: 2, description: "Все учебники и принадлежности" },
          ],
        },
        {
          key: "homework",
          title: "Домашние задания",
          options: [
            { value: 0, description: "Не выполнено" },
            { value: 1, description: "Выполнено частично" },
            { value: 2, description: "Все выполнены в тетрадях" },
          ],
        },
        {
          key: "appearance",
          title: "Внешний вид обучающегося",
          options: [
            { value: 0, description: "Без формы / грубые нарушения" },
            { value: 1, description: "В форме, но с нарушениями" },
            { value: 2, description: "Отличный вид" },
          ],
        },
        {
          key: "behavior",
          title: "Комментарии от учителей по поведению",
          options: [
            { value: 0, description: "Не ведет урок, не учится" },
            { value: 1, description: "Участие удовлетворительное" },
            { value: 2, description: "Активен на уроке" },
          ],
        },
        {
          key: "performance",
          title: "Текущая успеваемость",
          options: [
            { value: 0, description: "Двойки, тройки" },
            { value: 1, description: "Тройки, четверки" },
            { value: 2, description: "Четверки, пятерки" },
          ],
        },
        {
          key: "attendance",
          title: "Посещаемость",
          options: [
            { value: 0, description: "Пропуски по неуважительной причине" },
            { value: 1, description: "Мало пропусков по уважительной причине" },
            { value: 2, description: "Пропусков нет" },
          ],
        },
        {
          key: "extracurricular",
          title: "Дополнительная занятость",
          options: [
            { value: 0, description: "Не посещает кружки" },
            { value: 1, description: "Посещает один кружок" },
            { value: 2, description: "Посещает несколько кружков" },
          ],
        },
      ],
      loading: false,
    };
  },
  computed: {
    isFormValid() {
      return (
        this.formData.date &&
        this.formData.inspectorName &&
        this.formData.studentID &&
        Object.values(this.formData.evaluations).every(
          (value) => value !== null
        )
      );
    },
  },
  async mounted() {
    // Если переданы данные студента, заполняем автоматически
    if (this.studentData._id) {
      await this.getMarks();
      await this.getViolationsByStudent();

      let tempAttendance = null;

      if (this.marks.length === 0) {
        tempAttendance = null;
      } else {
        // Ищем хотя бы один неуважительный пропуск
        const hasUnexcused = this.marks.some(
          (mark) => mark.causesID === "Неуважительно"
        );

        if (hasUnexcused) {
          tempAttendance = 0;
        } else {
          // Проверяем, были ли вообще пропуски (любые, кроме присутствия)
          const hasAnyAbsence = this.marks.some(
            (mark) => mark.causesID !== "" && mark.causesID !== "Питался"
          );

          if (hasAnyAbsence) {
            tempAttendance = 1; // Есть пропуски, но уважительные
          } else {
            tempAttendance = 2; // Никаких пропусков
          }
        }
      }

      this.formData.evaluations["attendance"] = tempAttendance;
      this.formData.studentID = this.studentData._id;

      if (this.studentData.Clubs.length == 0) {
        this.formData.evaluations["extracurricular"] = 0;
      }
      if (this.studentData.Clubs.length == 1) {
        this.formData.evaluations["extracurricular"] = 1;
      }
      if (this.studentData.Clubs.length > 1) {
        this.formData.evaluations["extracurricular"] = 2;
      }
    }
  },
  methods: {
    async getViolationsByStudent() {
      await TutorialDataService.getViolationsByStudentId(this.studentData._id)
        .then((response) => {
          this.violationsList = response.data;

          // Проверка за последние 5 дней в одну строку
          const fiveDaysAgo = new Date(Date.now() - 5 * 24 * 60 * 60 * 1000);
          this.violationsCheck = response.data.some(
            (violation) => new Date(violation.date) >= fiveDaysAgo
          );
        })
        .catch((e) => {
          console.log(e);
          this.violationsCheck = false;
        });
    },
    async getMarks() {
      const dateFrom = new Date();
      dateFrom.setDate(dateFrom.getDate() - 8);

      await TutorialDataService.findMarksByDateRange({
        classID: { classID: this.studentData.classID },
        dateFrom: dateFrom.toISOString().slice(0, 10),
        dateBefore: new Date().toISOString().slice(0, 10),
        studentID: this.studentData._id,
      })
        .then((response) => {
          let temp = Object.values(response.data);

          for (let i = 0; i < temp.length; i++) {
            temp[i].date = new Date(temp[i].date).toLocaleDateString();
          }
          this.marks = Object.values(temp);
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getTodayDate() {
      const today = new Date();
      return today.toISOString().split("T")[0];
    },

    selectRating(criterion, value) {
      this.formData.evaluations[criterion] = value;
    },

    async submitForm() {
      if (!this.isFormValid) {
        alert(
          "Пожалуйста, заполните все обязательные поля и оцените все критерии"
        );
        return;
      }

      this.loading = true;

      try {
        await TutorialDataService.createAIC(this.formData)
          .then((response) => {
            console.log("УСПЕШНО ОТПРАВЛЕНО", response);
          })
          .catch((e) => {
            console.log("1111111111", e);
          });
        this.$emit("saved");
        this.$emit("close");
      } catch (error) {
        console.error("Ошибка при сохранении АИК:", error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.aic-modal {
  background: white;
  border-radius: 10px;
  max-width: 800px;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-header {
  background: linear-gradient(135deg, #4361ee, #3f37c9);
  color: white;
  padding: 18px 20px;
  border-radius: 10px 10px 0 0;
}

.modal-header h2 {
  font-size: 1.5rem;
  margin: 0;
}

.modal-body {
  padding: 20px;
}

.aic-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.basic-info {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

label {
  font-weight: 600;
  margin-bottom: 6px;
  font-size: 0.9rem;
  color: #212529;
}

input,
textarea {
  padding: 10px 12px;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  font-size: 0.9rem;
  transition: all 0.2s ease;
}

input:focus,
textarea:focus {
  outline: none;
  border-color: #4361ee;
  box-shadow: 0 0 0 2px rgba(67, 97, 238, 0.2);
}

.criteria-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 15px;
}

.criteria-item {
  padding: 12px;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  background: #fafbfc;
}

.criteria-title {
  font-weight: 600;
  margin-bottom: 8px;
  font-size: 0.9rem;
}

.rating-options {
  display: flex;
  gap: 10px;
}

.rating-option {
  flex: 1;
  text-align: center;
  padding: 8px 5px;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.85rem;
}

.rating-option:hover {
  background-color: #f0f2f5;
}

.rating-option.selected {
  background-color: #4895ef;
  color: white;
  border-color: #4361ee;
}

.rating-value {
  font-size: 1rem;
  font-weight: 700;
  margin-bottom: 3px;
}

.rating-desc {
  font-size: 0.8rem;
  line-height: 1.2;
}

.buttons {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 25px;
}

button {
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-submit {
  background: #4361ee;
  color: white;
}

.btn-submit:hover:not(:disabled) {
  background: #3f37c9;
  transform: translateY(-1px);
}

.btn-submit:disabled {
  background: #6c757d;
  cursor: not-allowed;
}

.btn-cancel {
  background: #e9ecef;
  color: #6c757d;
}

.btn-cancel:hover {
  background: #dee2e6;
}

@media (max-width: 600px) {
  .basic-info {
    grid-template-columns: 1fr;
  }

  .rating-options {
    flex-direction: column;
  }

  .buttons {
    flex-direction: column;
  }
}

.violation-alert {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 6px 6px;
  background: linear-gradient(135deg, #fff3cd, #ffeaa7);
  border: 1px solid #ffc107;
  border-radius: 8px;
  margin: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.alert-icon {
  font-size: 1.5em;
  flex-shrink: 0;
}

.alert-content {
  color: #856404;
  font-size: 0.95em;
}

.alert-content strong {
  font-weight: 600;
}
</style>
